import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import localforage from 'localforage';
import { useRecoilState } from 'recoil';
import { apiKeyState } from '#state';
import { getApiEndpoint } from '#state/utils';

const isDev = process.env.NODE_ENV !== 'production'
const appEnv = process.env.REACT_APP_ENV || 'DEV';
const apiBase = getApiEndpoint(appEnv)

const Auth = () => {
  const [key, setKey] = useState('');
  const [apiKey, setApiKey] = useRecoilState(apiKeyState);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    try {
      const response = isDev ? {} : await fetch(`${apiBase}?key=${key}`);

      if (response.status === 401) {
        setError('Invalid API key. Please try again.');
      } else {
        setError(null);
        try {
          await localforage.setItem('apiKey', key);
          window.apiKey = key;
          setApiKey(key);
          console.log('setApiKey', apiKey);
        } catch (error) {
          console.error('Failed to save API key:', error);
        }
      }
    } catch (error) {
      setError('Failed to validate API key: ' + error);
    }
  };

  return (
    <>
      <Dialog open={!apiKey}>
        <DialogTitle>Enter your API key</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="apikey"
            label="API Key"
            type="text"
            fullWidth
            onChange={(event) => {
              setKey(event.target.value);
            }}
            value={key}
            error={!!error}
            helperText={error}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Auth;
